import React, { forwardRef, useImperativeHandle, useState } from "react";
import "../messages/messages.css";

const FloatingMessage = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({ title: "", message: "" });

  useImperativeHandle(ref, () => ({
    show(msg) {
      setData({
        title: msg.summary,
        message: msg.detail
      });
      setVisible(true);

      setTimeout(() => {
        setVisible(false);
      }, msg.life || 4000);
    }
  }));

  if (!visible) return null;

 return (
    <div className="floating-msg-container">
      <div className="floating-msg-content">
        <i className="pi pi-info-circle floating-msg-icon"></i>


        <div className="floating-msg-text">
          <span className="floating-msg-title">{data.title}</span>
          <span className="floating-msg-body">{data.message}</span>
        </div>
      </div>

      <i
        className="pi pi-times floating-msg-close"
        onClick={() => setVisible(false)}
      ></i>
  </div>



);

});

export default FloatingMessage;
